<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-scale-multiple"></ngx-spinner>


<!-- El resto de tu HTML -->
<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header mb-2">
                <span>
                    <h3 class="text-center py-0">CUMPLIMIENTO DE INDICADORES</h3>
                </span>
            </div>
            <div *ngIf="dataMapConfigIndicador.length < 1" class="col-sm-6 text-sm-right pb-2">
                <div *hasDenied="{nivel:idSprNivel, app: constant.INDICADORES}">
                    <button *hasPermission="{app: constant.INDICADORES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                            class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                </div>
            </div>
            <div class="container card-body table-responsive " style="background-color: #f2f3f4; border-radius:20px; border:1px solid  #d3d4d6;box-shadow: 2px 2px 5px #999 ">
                <div class="form-group row mb-2">
                    <div class="col col-md-3">
                        <b><span style="text-align:right; display:block">Frecuencia:</span></b>
                    </div>
                    <div class="col col-md-3">
                        <span>{{titulosConfigIndicador[0].nombreFrecuencia}}</span>
                    </div>
                    <div class="col col-md-3">
                        <b><span style="text-align:right; display:block">Tipo:</span></b>
                    </div>
                    <div class="col col-md-3">
                        <span>{{titulosConfigIndicador[0].nombreTipo}}</span>
                    </div>
                </div>

                <div class="form-group row mb-2">
                    <div class="col col-md-3">
                        <b><span style="text-align:right; display:block">Unidad medida:</span></b>
                    </div>
                    <div class="col col-md-3">
                        <span>{{titulosConfigIndicador[0].nombreUnidadMedida}}</span>
                    </div>
                    <div class="col col-md-3 ">
                        <b><span style="text-align:right; display:block">Expresión:</span></b>
                    </div>
                    <div class="col col-md-3">
                        <span>{{titulosConfigIndicador[0].nombreExpresion}}</span>
                    </div>
                </div>

                <div class="form-group row mb-2">
                    <div class="col col-md-3">
                        <b><span style="text-align:right; display:block">Comportamiento:</span></b>
                    </div>
                    <div class="col col-md-9">
                        <span>{{titulosConfigIndicador[0].nombreComportamiento}}</span>
                    </div>
                </div>
            </div>

            <!--######################################################-->
            <div class="container card-body table-responsive">
                <div class="form-group row" *ngIf="dataMapConfigIndicador.length > 0" style="background-color: #f2f3f4">
                    <div class="col text-center  border">
                        <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn text-center btn-sm pt-2 btn-link waves-effect rounded-pill" title="Editar este registro" (click)="edit(dataMapConfigIndicador[0])">
                            <i class="fas fa-pencil-alt fa-lg"></i>
                            <p class="text-center">Editar configuración</p>
                        </button>
                    </div>

                    <div *ngIf="dataMapConfigIndicador[0].formula == 1" class="col text-center border">
                        <button type="button" tooltip="Editar" class="btn btn-sm pt-2 btn-link waves-effect rounded-pill" title="Editar este registro" (click)="openModalAgrupaIndicadores(dataMapConfigIndicador[0])">
                            <i class="fas fa-cubes fa-lg"></i>
                            <p class="text-center">Config. Agrupación</p>
                        </button>
                    </div>

                    <div *ngIf="dataMapConfigIndicador[0].formula == 2 || dataMapConfigIndicador[0].formula == null" class="col text-center border"> <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm pt-2 btn-link waves-effect rounded-pill" title="Ingresar metas" (click)="openModalSetCumpleIndicadores(dataMapConfigIndicador[0])">
                            <i class="fas fa-list fa-lg"></i>
                            <p class="text-center">Ingresar metas</p>
                        </button>
                    </div>
                    <div *ngIf="dataMapConfigIndicador[0].formula == 1" class="col text-center border"> <button type="button" tooltip="Editar" class="btn btn-sm pt-2 btn-link waves-effect rounded-pill" title="Actualizar metas" (click)="creMetasResultadosIndicadores()">
                            <i class="fas fa-sync-alt fa-lg"></i>
                            <p class="text-center">Actualizar metas/resultados</p>
                        </button>
                    </div>

                    <div class="col text-center border" *hasPermission="{app: constant.INDICADORES, permission: [constant.BORRAR]}">
                        <button  type="button" class="btn btn-sm pt-2 btn-link waves-effect" title="Eliminar este registro" (click)="deleteConfigIndicador(dataMapConfigIndicador[0].idSprConfigIndicador)">
                            <i class="fas fa-trash-alt fa-lg"></i>
                            <p class="text-center">Borrar configuración</p>
                        </button>
                    </div>
                </div>
            </div>

            <div class="p-2 mb-2 py-1">
                <div class="card-header">
                    <span><b>Indicador: </b>{{ nameApp1 }}</span>
                </div>
            </div>


            <div class="container card-body table-responsive pt-0">

                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Periódo</th>
                            <th>Cumplimiento</th>
                            <th *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA') || (identificadorUnidadMedida == 'NUMERO')">
                                Meta del Período
                            </th>
                            <th *ngIf="identificadorUnidadMedida == 'VARIACION'">Meta Anterior</th>
                            <th *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA')">
                                Numerador del Período</th>
                            <th *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA')">
                                Denominador del Período</th>
                            <th *ngIf="identificadorUnidadMedida == 'NUMERO'">Resultado del Período</th>
                            <th *ngIf="identificadorUnidadMedida == 'VARIACION'">Período Actual</th>
                            <th>Documento de soporte</th>

                            <th>Cumplir Indicador</th>
                            <th>Administrar</th>

                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let row of dataOrdenaMapCumpleIndicador;let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{row.nombre}}</td>
                            <td>{{((row.cumplido === 'N')? 'NO' : 'SI')}}</td>
                            <td>
                                <div *ngIf="(identificadorUnidadMedida == 'PORCENTAJE')">{{row.metaPeriodo}} % </div>
                                <div *ngIf="(identificadorUnidadMedida != 'PORCENTAJE')">{{row.metaPeriodo}} </div>
                            </td>
                            <td *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA') || (identificadorUnidadMedida == 'NUMERO') ||(identificadorUnidadMedida == 'VARIACION')">
                                {{row.numerador}}
                            </td>
                            <td *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA')">
                                {{row.denominador}}
                            </td>
                            <td>
                                <div *ngIf="row.respaldoPdf != null">
                                    <button type="button" tooltip="Visualizar pdf respaldo" class="btn btn-sm btn-link waves-effect rounded-pill" title="Editar este registro" (click)="visualizarPdf(row.respaldoPdf)">
                                        <i class="fas fa-file-pdf  fa-lg"></i>
                                        <div class="text-center">
                                            <span (click)="visualizarPdf(row.respaldoPdf)">{{row.respaldoPdf}}</span>
                                        </div>
                                    </button>
                                </div>
                            </td>

                            <td class="text-center size">
                                <!-- <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Editar este registro" (click)="openModalCumplirIndicador(row)">
                                    <i class=" far fa-check-square fa-lg"></i>
                                </button> -->
                                 <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Cumplir indicador" (click)="openModalCumplirIndicador(row)">
                                    <i class=" far fa-check-square fa-lg"></i>
                                </button>

                            </td>
                            <td class="text-center">

                                <div *hasDenied="{nivel:idSprNivel, app: constant.INDICADORES}">
                                    <div *ngIf="dataMapConfigIndicador[0].formula == 1" class="row">
                                        <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="editMetaPerido(row)">
                                            <i class="fas fa-pencil-alt fa-lg"></i>
                                        </button>
                                        <!--<button *hasPermission="{app: constant.INDICADORES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro.." (click)="deleteCumpleIndicador(row.idSprCumpleIndicador)">
                                            <i class="fas fa-trash-alt fa-lg"></i>
                                        </button>-->
                                    </div>
                                    <div *ngIf="dataMapConfigIndicador[0].formula == 2 || dataMapConfigIndicador[0].formula == null" class="row">
                                        <button *hasPermission="{app: constant.INDICADORES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="editMetaPerido(row)">
                                            <i class="fas fa-pencil-alt fa-lg"></i>
                                        </button>
                                        <!--<button *hasPermission="{app: constant.INDICADORES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro.." (click)="deleteCumpleIndicador(row.idSprCumpleIndicador)">
                                            <i class="fas fa-trash-alt fa-lg"></i>
                                        </button>-->
                                    </div>
                                </div>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    </div>
</div>

<jw-modal id="delete">
    <div class="modal-dialog" style="padding-top:15%">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                <button type="button" class="btn-close" (click)="modal.close()"></button>
            </div>
            <div class="modal-body">
                <p class="pl-4"><i class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp; &nbsp; Esta seguro que desea eliminar este registro? </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.close();">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="confirmDelete()">Si, borrar!</button>
            </div>
            <div *ngIf="isDeleting" class="spinner">Eliminando...</div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</jw-modal>
<!-- ############################################################## -->
<!-- ELIMINAR COMFIGURACION DE INDICADOR -->
<!-- ############################################################## -->
<jw-modal id="delete-config-indicador">
    <div class="modal-dialog" style="padding-top:15%">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                <button type="button" class="btn-close" (click)="modal.closeId('delete-config-indicador')"></button>
            </div>
            <div class="modal-body">
                <p class="pl-4"><i class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp; &nbsp; Esta seguro que desea eliminar este registro? </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId('delete-config-indicador')">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="confirmDelete('delete-config-indicador')">Si,
                    borrar!</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</jw-modal>

<!-- ############################################################## -->
<!-- ELIMINAR CUMPLIMINETO DE INDICADOR -->
<!-- ############################################################## -->
<jw-modal id="delete-cumple-indicador">
    <div class="modal-dialog" style="padding-top:15%">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                <button type="button" class="btn-close" (click)="modal.closeId('delete-cumple-indicador')"></button>
            </div>
            <div class="modal-body">
                <p class="pl-4"><i class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp; &nbsp; Esta seguro que desea eliminar este registro..? </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId('delete-cumple-indicador')">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="confirmDeleteCumpleIndicador('delete-cumple-indicador')">Si, borrar!</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</jw-modal>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO DE LA AGRUPACION DE INIDCADORES  -->





<!-- ################################################################ -->
<!--Modal crear configuracion del indicador-->
<!-- ################################################################ -->
<jw-modal id="{{modalConfigIndicador}}">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="modal.closeId(modalConfigIndicador);" aria-label="Close"></button>
            </div>

            <div class="modal-body pT-4">
                <div class="card-header  mb-2">
                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><span style="text-align:right; display:block">INDICADOR:</span></b>
                        </div>
                        <div class="col col-md-8">
                            <span>{{nameApp1}}</span>
                        </div>
                    </div>
                </div>

                <form action="#" [formGroup]="formConfiguracionIndicadores" class="needs-validation">
                    <div class="bg-white shadow-sm p-2 mb-2 bg-white rounded">
                        <strong class="font-weight-bold">CLASIFICACIÓN</strong>
                      </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprFrecuencia" class=" form-control-label text-md-right pt-1"><b>Frecuencia:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-9" formControlName="idSprFrecuencia" required="true" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('idSprFrecuencia')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('idSprFrecuencia')?.errors,}">
                                <option *ngFor="let catFrecuencia of dataFrecuenciaCatalogo"
                                    value={{catFrecuencia.idSprComun}} [disabled]="disableSelect.value">
                                    {{catFrecuencia.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('idSprFrecuencia')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</span>
                            </div>
                        </div>

                        <div class="col col-md-2 text-md-right">
                            <label for="idSprComportamiento" class=" form-control-label text-md-right pt-1"><b>Comportamiento:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-9" formControlName="idSprComportamiento" required="true" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('idSprComportamiento')?.errors && this.formSubmitted, 'is-valid': !this.formConfiguracionIndicadores.get('idSprComportamiento')?.errors,}">

                                <option *ngFor="let catComportamiento of dataComportamientoCatalogo"
                                    value={{catComportamiento.idSprComun}} [disabled]="disableSelect.value">
                                    {{catComportamiento.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('idSprComportamiento')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>


                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprUnidadMedida" class=" form-control-label text-md-right pt-1"><b>Unidad
                                    medida:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-12" id="idSprUnidadMedida" formControlName="idSprUnidadMedida" required="true" (ngModelChange)="obtenerExpreson($event)" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('idSprUnidadMedida')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('idSprUnidadMedida')?.errors,}">

                                <option *ngFor="let catUnidadMedida of dataUniMedidaEspecialDos"
                                    value={{catUnidadMedida.idSprEspecialDos}} [disabled]="disableSelect.value">
                                    {{catUnidadMedida.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('idSprUnidadMedida')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</span>
                            </div>
                        </div>


                        <div class="col col-md-2 text-md-right">
                            <label for="idSprExpresion" class=" form-control-label text-md-right pt-1"><b>Expresión:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input *ngIf="expresionCatalogo.length != 0 " id="idSprExpresion" type="text" class="form-control" required="false" readonly="true" style="background-color: #e9e8e8" formControlName="idSprExpresion" placeholder="{{expresionCatalogo[0].nombre}}" value={{expresionCatalogo[0].nombre}}
                            />
                        </div>
                    </div>


                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprTipoIndicador" class=" form-control-label text-md-right pt-1"><b>Tipo:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <div *ngIf="tipoIndCatalogo.length == 1">
                                <input id="idSprTipoIndicador" type="text" class="form-control" required="false" readonly="true" style="background-color: #e9e8e8"  placeholder="{{tipoIndCatalogo[0].nombre}}" />
                            </div>

                            <div *ngIf="tipoIndCatalogo.length > 1 || tipoIndCatalogo.length == 0">
                                <select class="form-select col-9" formControlName="idSprTipoIndicador" required="true" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('idSprTipoIndicador')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('idSprTipoIndicador')?.errors,}">

                                    <option *ngFor="let catTipoIndicador of tipoIndCatalogo"
                                        value={{catTipoIndicador.idSprEspecialUno}} [disabled]="disableSelect.value">
                                        {{catTipoIndicador.nombre}}
                                    </option>
                                </select>
                                <div class="col text-danger">
                                    <span class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('idSprTipoIndicador')?.errors?.['required'] && this.formSubmitted">Campo
                                        requerido</span>
                                </div>
                            </div>
                        </div>

                        <div class="col col-md-2 text-md-right">
                            <label for="idSprJerarquia" class=" form-control-label text-md-right pt-1"><b>Jerarquía:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-12" id="idSprJerarquia" formControlName="idSprJerarquia" required="true" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('idSprJerarquia')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('idSprJerarquia')?.errors,}">

                                <option *ngFor="let tipo of dataJerarquiaCatalogo" value={{tipo.idSprEspecialUno}}
                                    [disabled]="disableSelect.value">
                                    {{tipo.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('idSprJerarquia')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="lineaBase" class=" form-control-label text-md-right pt-1"><b>Linea
                                    base:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input type="hidden" id="idSprConfigIndicador" formControlName="idSprConfigIndicador" requiered class="is-invalid">
                            <input type="text" step="0.01" class="form-control" required="true" [readonly]="dasactivarCamposFormConfig" placeholder="Línea base" 
                            (keypress)="allowHourOrNumber($event)"  
                            (blur)="validateNumberOrTime()"
                            placeholder="Ej: 123 o 12:30:45"
                                formControlName="lineaBase" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('lineaBase')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('lineaBase')?.errors,}">
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('lineaBase')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                    </div>
                    <div class="bg-white shadow-sm p-2 mb-2 bg-white rounded">
                        <strong class="font-weight-bold">AGRUPACIÓN INDICADOR</strong>
                      </div>
                    <div *ngIf="idLineaAccionHabilitarCampo == true">
                        <div *ngIf="idPlanAccionHabilitarCampo == true">
                            <div *ngIf="idProyectoHabilitarCampo == true">
                                <div *ngIf="idProcesoHabilitarCampo == true">
                                    <div *ngIf="idSprNivel != idSprNivelN5">
                                        <div class="form-group row mb-2">
                                            <div class="col col-md-3 text-md-right">
                                                <label for="formula" class=" form-control-label text-md-right pt-1"><b>Agrupado?:</b></label>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <select class="form-select " id="formula" formControlName="formula" required="true" (ngModelChange)="openTipoAgrupacion($event)" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('formula')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('formula')?.errors,}">

                                                    <option [value]="item.value" *ngFor="let item of selectAgrupacion"
                                                        [disabled]="disableSelect.value">
                                                        {{item.label}}
                                                    </option>
                                                </select>
                                                <div class="col text-danger">
                                                    <small class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('formula')?.errors?.['required'] && this.formSubmitted">Campo
                                                        requerido</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="this.openlabelTipoAgrupacion == true" class="form-group row mb-2">
                        <div class="col col-md-3 text-md-right">
                            <label for="idSprTipoAgrupacion" class=" form-control-label text-md-right"><b>Tipo de agrupación:</b></label>
                        </div>
                        <div class="col-12 col-md-6">
                            <select class="form-select col-12" id="idSprTipoAgrupacion" formControlName="idSprTipoAgrupacion" required="true" (ngModelChange)="obtenerTipoAgrupacion($event)" [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('idSprTipoAgrupacion')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('idSprTipoAgrupacion')?.errors,}">
                                <option *ngFor="let tipo of dataTipoAgrupacion" value={{tipo.idSprEspecialDos}}
                                    [disabled]="disableSelect.value">
                                    {{tipo.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formConfiguracionIndicadores.get('idSprTipoAgrupacion')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="this.openlabelTipoAgrupacion == false" class="form-group row mb-2">
                        <input type="hidden" id="idSprTipoAgrupacion" formControlName="idSprTipoAgrupacion" requiered="false" class="is-invalid">
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-3 text-md-right">
                            <label for="estado" class=" form-control-label text-md-right pt-1"><b>Estado:</b></label>
                        </div>
                        <div class="col-12 col-md-6">
                            <select id="estado" class="form-select" formControlName="estado" required [ngClass]="{'is-invalid': this.formConfiguracionIndicadores.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formConfiguracionIndicadores.get('estado')?.errors,}">
                                <option [value]="item.value" *ngFor="let item of selectItems"
                                    [disabled]="disableSelect.value">
                                    {{item.label}}
                                </option>
                            </select>
                            <small class="invalid-feedback" *ngIf="formSubmitted && procesoForm['estado'].errors">Campo
                                requerido</small>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId(modalConfigIndicador);">Cerrar</button>
                <button *ngIf="dasactivarCamposFormConfig != true" type="button" class="btn btn-info" (click)="onSubmit()">Guardar!</button>
            </div>
        </div>
    </div>
</jw-modal>

<!-- ######################################################################## -->
<!--Modal crear indicadores Admin para cumplimiento -->
<!-- ######################################################################## -->

<jw-modal id="{{modalIngresoMetas}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp2}}</h3>
                <button type="button" class="btn-close" (click)="closeModalCumplimientoIndicadorAdmin(modalIngresoMetas);" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <div class="card-header  mb-2">
                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><span style="text-align:right; display:block">INDICADOR:</span></b>
                        </div>
                        <div class="col col-md-8">
                            <span>{{nameApp1}}</span>
                        </div>
                    </div>
                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><span style="text-align:right; display:block">Línea base:</span></b>
                        </div>
                        <div class="col col-md-8">
                            <span>{{lineaBaseMetaIndicador}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="dataMapConfigIndicador.length > 0" class="col-sm-6 text-sm-right pb-2">
                    <div *ngIf="this.dataMapConfigIndicador[0].formula == 1">
                        <!--<button *ngIf="(lengthIndicadoresAgrupados > 0)" type="button"
                            class="btn btn-sm btn-success waves-effect"
                            (click)="calculoMetaResultados(dataMapCumpleIndicador)"><i
                                class="fas fa-plus fa-lg mr-2"></i> Procesar
                            Meta</button>-->
                    </div>
                </div>

                <form action="#" [formGroup]="formCreaIndicadorAdmin" class="needs-validation" novalidate>
                    <input type="hidden" id="idSprCumpleIndicador" formControlName="idSprCumpleIndicador" class="is-invalid">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                        <thead>
                            <tr>
                                <th>Nro.</th>
                                <th>Periódo</th>
                                <th>Meta</th>
                                <!--<th>Administrar</th>-->
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let fila of dataOrdenaMapCumpleIndicador; let indice=index">
                                <td>{{indice+1}}</td>
                                <td>
                                    <a><label for={{fila.idSprAtribucion}} class="form-check-label">
                                            {{fila.nombre}}{{addMetas()}}
                                        </label></a>
                                </td>
                                <td>

                                  
                                    <div *ngIf="dataMapConfigIndicador[0].formula == 2 && dataMapConfigIndicador[0].unidadMedida !== 'TIEMPO'" formArrayName="metasPeriodos">
                                        <div [formGroupName]="indice">
                                            <input *ngIf="(dasactivarCamposFormMeta == false)" [attr.id]="'metaPeriodo'+indice" formControlName="metaPeriodo" type="number" class="form-control" id="valor" min="0" max="100" step="0.01" maxlength="6" required="true" placeholder="" onkeypress="return ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))">
                                            <input *ngIf="dasactivarCamposFormMeta == true" [attr.id]="'metaPeriodo'+indice" formControlName="metaPeriodo" type="number" class="form-control" [readonly]="dasactivarCamposFormMeta" style="background-color: #e9e8e8">
                                        </div>
                                    </div>
                                    <div *ngIf="dataMapConfigIndicador[0].formula == 1 && dataMapConfigIndicador[0].unidadMedida !== 'TIEMPO'" formArrayName="metasPeriodos">
                                        <div [formGroupName]="indice">
                                            <input [attr.id]="'metaPeriodo'+indice" formControlName="metaPeriodo" type="number" class="form-control" [readonly]="desahabilitarInput" style="background-color: #e9e8e8">
                                        </div>
                                    </div>
                                    <div *ngIf="dataMapConfigIndicador[0].formula == null && dataMapConfigIndicador[0].unidadMedida !== 'TIEMPO'" formArrayName="metasPeriodos">
                                        <div [formGroupName]="indice">
                                            <input *ngIf="(dasactivarCamposFormMeta == false)" [attr.id]="'metaPeriodo'+indice" formControlName="metaPeriodo" type="number" class="form-control" id="valor" min="0" max="100" step="0.01" maxlength="6" required="true" placeholder="" onkeypress="return ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))">
                                            <input *ngIf="dasactivarCamposFormMeta == true" [attr.id]="'metaPeriodo'+indice" formControlName="metaPeriodo" type="number" class="form-control" [readonly]="dasactivarCamposFormMeta" style="background-color: #e9e8e8">
                                        </div>
                                    </div>
                                    <div *ngIf="dataMapConfigIndicador[0].unidadMedida == 'TIEMPO'" formArrayName="metasPeriodos">
                                         <div [formGroupName]="indice">
                                            <input *ngIf="(dasactivarCamposFormMeta == false)" 
                                            [attr.id]="'metaPeriodo'+indice" 
                                            formControlName="metaPeriodo" 
                                            type="text" 
                                            class="form-control" 
                                            id="valor"  
                                            required="true"
                                            [value]="dataMapConfigIndicador[0].lineaBase" 
                                            placeholder="Ej: 23:59:59" 
                                            onkeypress="return (event.charCode == 58 || (event.charCode >= 48 && event.charCode <= 57))" 
                                            (blur)="validarHora($event)"
                                            pattern="^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$"
                                            [attr.value]="dataMapConfigIndicador[0]?.lineaBase || '00:00:00'"
                                            >
                                            <input *ngIf="dasactivarCamposFormMeta == true" [attr.id]="'metaPeriodo'+indice" formControlName="metaPeriodo" type="number" class="form-control" [readonly]="dasactivarCamposFormMeta" style="background-color: #e9e8e8">
                                        </div>
                                    </div>
                                </td>
                                <!--<td class="text-center ">
                                    <div class="row">
                                        <button type="button" tooltip="Editar"
                                            class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                            title="Editar este registro">
                                            <i class="fas fa-pencil-alt fa-lg"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                            title="Eliminar este registro..">
                                            <i class="fas fa-trash-alt fa-lg"></i>
                                        </button>
                                    </div>
                                </td>-->
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalCumplimientoIndicadorAdmin(modalIngresoMetas);">Cerrar</button>
                <div *hasPermission="{app: constant.INDICADORES, permission: [constant.CREAR]}">
                    <div *ngIf="dataMapConfigIndicador.length > 0">
                        <button *ngIf="(dasactivarCamposFormMeta != true)&&(dataMapConfigIndicador[0].formula == 2 )" type="button" class="btn btn-info" (click)="crearMetaPeriodo(dataMapCumpleIndicador)">Guardar</button>
                    </div>
                    <div *ngIf="dataMapConfigIndicador.length > 0">
                        <button *ngIf="(dasactivarCamposFormMeta != true)&&(dataMapConfigIndicador[0].formula == null )" type="button" class="btn btn-info" (click)="crearMetaPeriodo(dataMapCumpleIndicador)">Guardar!</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</jw-modal>

<jw-modal id="{{modalEditMetas}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp2}}</h3>
                <button type="button" class="btn-close" (click)="closeModalCumplimientoIndicadorAdmin(modalEditMetas);" aria-label="Close"></button>
            </div>
            <div class="modal-body px-5">
                <form action="#" [formGroup]="formCreaIndicadorAdmin" class="needs-validation" novalidate>
                    <div class="shadow-sm p-2 mb-2 bg-body rounded">GESTIÓN DE CUMPLIMIENTOS.</div>

                    <div class="form-group row mb-2 pt-2">
                        <div class="col col-md-2 text-md-right ">
                            <label for="idNombrePeriodo" class="col-form-label text-md-right"><b>Periodo:</b>
                            </label>
                        </div>
                        <div class="col-12 col-md-4 ">
                            <input id="idNombrePeriodo" type="text" class="form-control" required="true" readonly="true" style="background-color: #e9e8e8" formControlName="nombrePeriodo" />
                        </div>

                        <div class="col col-md-2 text-md-right">
                            <label for="metaPeriodo" class=" form-control-label text-md-right pt-1"><b>Meta
                                    período:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <div *ngIf="dataMapConfigIndicador.length > 0">
                            <input *ngIf="dataMapConfigIndicador[0].formula == 2 || dataMapConfigIndicador[0].formula == null" type="number" id="metaPeriodo" formControlName="metaPeriodo" required="true" class="is-invalid" min="0" max="100" class="form-control" placeholder="Meta período" onkeypress="return
                            ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))"  [ngClass]="{'is-invalid': this.formCreaIndicadorAdmin.get('metaPeriodo')?.errors && this.formSubmitted,'is-valid': !this.formCreaIndicadorAdmin.get('metaPeriodo')?.errors,}">

                            <input *ngIf="dataMapConfigIndicador[0].formula == 1" type="number" id="metaPeriodo" formControlName="metaPeriodo" class="is-invalid" min="0" max="100" class="form-control" placeholder="Meta período" readonly="true" style="background-color: #e9e8e8">
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formCreaIndicadorAdmin.get('metaPeriodo')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <input type="hidden" id="idSprCumpleIndicador" formControlName="idSprCumpleIndicador" class="is-invalid">
                            <label for="fechaInicio" class=" form-control-label text-md-right pt-1"><b>Fecha
                                    Inicio:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input type="date" class="form-control" required="true" placeholder="fechaInicio" formControlName="fechaInicio" readonly="true" style="background-color: #e9e8e8">
                        </div>


                        <div class="col col-md-2 text-md-right">
                            <label for="fechaFin" class=" form-control-label text-md-right pt-1"><b>Fecha
                                    fin:</b></label>
                        </div>
                        <div *ngIf="idSprRolPrincipal != idRolAnalistaMetodologico" class="col-12 col-md-4">
                            <input type="date" class="form-control" required="true" placeholder="fechaFin" formControlName="fechaFin" readonly="true" style="background-color: #e9e8e8">
                        </div>
                        <div *ngIf="idSprRolPrincipal == idRolAnalistaMetodologico" class="col-12 col-md-4">
                            <input type="date" class="form-control" required="true" placeholder="fechaFin" formControlName="fechaFin">
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalCumplimientoIndicadorAdmin(modalEditMetas);">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="editarMetaPeriodo()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>



<!-- ############################################################################## -->
<!-- MODAL CUMPLIR INDICADOR -->
<!-- ############################################################################## -->
<jw-modal id="{{modalCumpleIndicadorNumDeno}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp3}}</h3>

                <button type="button" class="btn-close" (click)="closeModalCumplirIndicador();" aria-label="Close"></button>
            </div>

            <div class="modal-body pT-4">
                <form action="#" [formGroup]="formCumpleIndicador" class="needs-validation" novalidate>

                    <div class="card-header mb-2">
                        <span><h1 style="font-size: small; font-weight: normal;">{{ cumplimientoIndicador }}</h1></span>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="periodo" class=" form-control-label text-md-right pt-1"><b>Comentario:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea class="form-control" id="comentario" placeholder="Ingrese un comentario" formControlName="comentario" rows="3" cols="30" [ngClass]="{'is-invalid': this.formCumpleIndicador.get('comentario')?.errors && this.submitted,'is-valid': !this.formCumpleIndicador.get('comentario')?.errors,}">
                            </textarea>
                            <small class="invalid-feedback" *ngIf="this.formCumpleIndicador.get('comentario')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="respaldoPdf" class=" form-control-label text-md-right pt-1"><b>Documento de
                                    Soporte:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <input #myInput type="file" class="form-control" accept=".pdf" id="respaldoPdf" formControlName="respaldoPdf" (change)="capturarFile($event)" [ngClass]="{'is-invalid': this.formCumpleIndicador.get('respaldoPdf')?.errors && this.submitted,'is-valid': !this.formCumpleIndicador.get('respaldoPdf')?.errors,}">
                            <small class="invalid-feedback" *ngIf="this.formCumpleIndicador.get('respaldoPdf')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                        </div>
                    </div>
                    <div *ngIf="dataMapConfigIndicador.length > 0">
                        <div *ngIf="dataMapConfigIndicador[0].formula == 2 || dataMapConfigIndicador[0].formula == null" class="form-group row mb-2">

                            <div class="col col-md-2 text-md-right">
                                <input type="hidden" id="idSprCumpleIndicador" formControlName="idSprCumpleIndicador" class="is-invalid">
                                <label for="numerador" class=" form-control-label text-md-right pt-1">
                                    <b *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA')">Numerador del periodo: </b>
                                    <b *ngIf="identificadorUnidadMedida == 'NUMERO'">Resultado del periodo:</b>
                                    <b *ngIf="identificadorUnidadMedida == 'VARIACION'">Periodo Actual</b>
                                </label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input type="number" class="form-control" id="valor" min="0" max="100000000" step="0.01" maxlength="6" required="true" placeholder=""  formControlName="numerador"
                                    [ngClass]="{'is-invalid': this.formCumpleIndicador.get('numerador')?.errors && this.submitted,'is-valid': !this.formCumpleIndicador.get('numerador')?.errors,}"
                                    onkeypress="return ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))"
                                    placeholder="1"
                                    >
                                <small class="invalid-feedback" *ngIf="this.formCumpleIndicador.get('numerador')?.errors?.['required'] && this.submitted">Campo
                                    requerido</small>
                            </div>

                            <div class="col col-md-2 text-md-right">
                                <label for="fechaFin" class=" form-control-label text-md-right pt-1">
                                    <b>Denominador del periodo:</b>
                                </label>
                            </div>
                            <div class="col-12 col-md-4" *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA')">
                                <input type="number" class="form-control" id="valor" min="0" max="100000000" step="0.01" maxlength="6" required="true" placeholder="" onkeypress="return ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))" formControlName="denominador"
                                    [ngClass]="{'is-invalid': this.formCumpleIndicador.get('denominador')?.errors && this.submitted,'is-valid': !this.formCumpleIndicador.get('denominador')?.errors,}" placeholder="2">
                                <small class="invalid-feedback" *ngIf="this.formCumpleIndicador.get('denominador')?.errors?.['required'] && this.submitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalCumplirIndicador();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="subirArchivo()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>

<jw-modal id="{{modalCumpleIndicadorComentario}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp3}}</h3>

                <button type="button" class="btn-close" (click)="closeModalCumplirIndicador();" aria-label="Close"></button>
            </div>

            <div class="modal-body pT-4">
                <form action="#" [formGroup]="formCumpleIndicadorComentario" class="needs-validation" novalidate>

                    <div class="card-header mb-2">
                        <span><h1 style="font-size: small; font-weight: normal;">{{ cumplimientoIndicador }}</h1></span>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="periodo" class=" form-control-label text-md-right pt-1"><b>Comentario:
                                </b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea class="form-control" id="comentario" placeholder="Ingrese un comentario" formControlName="comentario" rows="3" cols="30" required="true" [ngClass]="{'is-invalid': this.formCumpleIndicadorComentario.get('comentario')?.errors && this.submitted,'is-valid': !this.formCumpleIndicadorComentario.get('comentario')?.errors,}">
                            </textarea>
                            <small class="invalid-feedback" *ngIf="this.formCumpleIndicadorComentario.get('comentario')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="respaldoPdf" class=" form-control-label text-md-right pt-1"><b>Documento de
                                    Soporte:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <input #myInput type="file" class="form-control" accept=".pdf" id="respaldoPdf" formControlName="respaldoPdf" (change)="capturarFile($event)" [ngClass]="{'is-invalid': this.formCumpleIndicadorComentario.get('respaldoPdf')?.errors && this.submitted,'is-valid': !this.formCumpleIndicadorComentario.get('respaldoPdf')?.errors,}">
                            <small class="invalid-feedback" *ngIf="this.formCumpleIndicadorComentario.get('respaldoPdf')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalCumplirIndicador();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="subirArchivo()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>

<jw-modal id="{{modalCumpleIndicadorNumerador}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp3}}</h3>

                <button type="button" class="btn-close" (click)="closeModalCumplirIndicador();" aria-label="Close"></button>
            </div>

            <div class="modal-body pT-4">
                <form action="#" [formGroup]="formCumpleIndicadorNumerador" class="needs-validation" novalidate>

                    <div class="card-header mb-2">
                        <span><h1 style="font-size: small; font-weight: normal;"><b>Perido:</b>{{ cumplimientoIndicador }}</h1></span>
                        <span><h1 style="font-size: small; font-weight: normal;"><b>Meta:</b> {{ metaPeriodoCumpleIndicador }}</h1></span>
                    </div>
                   

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="periodo" class=" form-control-label text-md-right pt-1"><b>Comentario:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea class="form-control" id="comentario" placeholder="Ingrese un comentario" formControlName="comentario" rows="3" cols="30" [ngClass]="{'is-invalid': this.formCumpleIndicadorNumerador.get('comentario')?.errors && this.submitted,'is-valid': !this.formCumpleIndicadorNumerador.get('comentario')?.errors,}">
                            </textarea>
                            <small class="invalid-feedback" *ngIf="this.formCumpleIndicadorNumerador.get('comentario')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                        </div>
                    </div>

                  
                    <div *ngIf="dataMapConfigIndicador.length > 0">
                        <div *ngIf="dataMapConfigIndicador[0].formula == 2  || dataMapConfigIndicador[0].formula == null" class="form-group row mb-2">

                            <div class="col col-md-2 text-md-right">
                                <input type="hidden" id="idSprCumpleIndicador" formControlName="idSprCumpleIndicador" class="is-invalid">
                                <label for="numerador" class=" form-control-label text-md-right pt-1">
                                    <b
                                        *ngIf="(identificadorUnidadMedida == 'PORCENTAJE') || (identificadorUnidadMedida == 'BANDA')">Numerador del periodo: </b>
                                    <b *ngIf="identificadorUnidadMedida == 'NUMERO'">Resultado del periodo.:</b>
                                    <b *ngIf="identificadorUnidadMedida == 'VARIACION'">Periodo Actual</b>
                                </label>
                            </div>
                            <div *ngIf="!esTipoTiempo" class="col-12 col-md-10">
                                <input type="number" class="form-control" id="valor" min="0" max="10000" step="0.01" maxlength="6" required="true" placeholder="" onkeypress="return ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))" formControlName="numerador"
                                    [ngClass]="{'is-invalid': this.formCumpleIndicadorNumerador.get('numerador')?.errors && this.submitted,'is-valid': !this.formCumpleIndicadorNumerador.get('numerador')?.errors,}" placeholder="Ej: 124.45">
                                <small class="invalid-feedback" *ngIf="this.formCumpleIndicadorNumerador.get('numerador')?.errors?.['required'] && this.submitted" >Campo
                                    requerido</small>
                            </div>
                            <div *ngIf="esTipoTiempo" class="col-12 col-md-10">
                                <input type="text" class="form-control" id="valor" required="true" placeholder="" formControlName="numerador"
                                    [ngClass]="{'is-invalid': this.formCumpleIndicadorNumerador.get('numerador')?.errors && this.submitted,'is-valid': !this.formCumpleIndicadorNumerador.get('numerador')?.errors,}" placeholder="Ej: 23:59:59"
                                    onkeypress="return (event.charCode == 58 || (event.charCode >= 48 && event.charCode <= 57))" 
                                    (blur)="validarHora($event)"
                                    pattern="^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$"
                                    >
                                <small class="invalid-feedback" *ngIf="this.formCumpleIndicadorNumerador.get('numerador')?.errors?.['required'] && this.submitted" >Campo
                                    requerido</small>
                            </div>

                        </div>
                    </div>
                      <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="respaldoPdf" class=" form-control-label text-md-right pt-1"><b>Documento de
                                    Soporte:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <input #myInput type="file" class="form-control" accept=".pdf" id="respaldoPdf" formControlName="respaldoPdf" (change)="capturarFile($event)" [ngClass]="{'is-invalid': this.formCumpleIndicadorNumerador.get('respaldoPdf')?.errors && this.submitted,'is-valid': !this.formCumpleIndicadorNumerador.get('respaldoPdf')?.errors,}">
                            <small class="invalid-feedback" *ngIf="this.formCumpleIndicadorNumerador.get('respaldoPdf')?.errors?.['required'] && this.submitted">Campo
                                requerido</small>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalCumplirIndicador();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="subirArchivo()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>


<jw-modal id="{{modalAgrupaIndicadores}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="closeModalAgrupacion(modalAgrupaIndicadores);" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <div class="card-header  mb-2">
                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><span style="text-align:right; display:block">INDICADOR:</span></b>
                        </div>
                        <div class="col col-md-8">
                            <span>{{nameApp1}}</span>
                        </div>
                    </div>
                </div>
                <div *hasDenied="{nivel:idSprNivel, app: constant.INDICADORES}" class="col-sm-6 text-sm-right pb-2">
                    <button *hasPermission="{app: constant.INDICADORES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModalFormularioAgrupacion()"><i
                            class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                </div>


                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Ambiente N. Inferior</th>
                            <th>Indicador N. Inferior</th>
                            <th *ngIf="this.openlabelValor == true">Ponderación</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let row of dataMapAgrupacionIndicador; let indice = index">
                            <td>{{indice+1}}</td>
                            <td>{{row.nombreAmbienteHijo}}</td>
                            <td>{{row.nombreIndicadorHijo}}</td>
                            <td *ngIf="this.openlabelValor == true">{{row.valor}} %</td>
                            <td class="text-center ">
                                <div *hasDenied="{nivel:idSprNivel, app: constant.INDICADORES}" class="row">
                                    <button *hasPermission="{app: constant.INDICADORES, permission: [constant.CREAR, constant.ACTUALIZAR]}" type="button" tooltip="Editar" (click)="editAgrupacion(row)" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button *hasPermission="{app: constant.INDICADORES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect " (click)="deleteAgrupacion(row.idSprAgrupaIndicador)" title="Eliminar este registro..">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>

                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalAgrupacion(modalAgrupaIndicadores);">Cerrar</button>
            </div>
        </div>

    </div>
</jw-modal>

<jw-modal id="{{modalFormularioAgrupacion}}">
    <div class="modal-dialog modal-lg  modal-dialog-scrollable" style="padding-top:6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{nameApp}}</h3>
                <button type="button" class="btn-close" (click)="closeModalFormularioAgrupacion();" aria-label="Close"></button>
            </div>
            <div class="modal-body pT-4">
                <div class="card-header  mb-2">
                    <div class="form-group row mb-2">
                        <div class="col col-md-2">
                            <b><span style="text-align:right; display:block">INDICADOR:</span></b>
                        </div>
                        <div class="col col-md-8">
                            <span>{{nameApp1}}</span>
                        </div>
                    </div>
                </div>
                <form action="#" [formGroup]="formAgrupacionIndicador" class="needs-validation">
                    <div class="form-group row mb-2">
                        <div class="col col-md-4 text-md-right">
                            <label for="idSprAmbiente" class=" form-control-label text-md-right pt-1"><b>Ambiente/ N.
                                    Inferior:</b></label>
                        </div>
                        <div class="col-12 col-md-8">
                            <input type="hidden" id="idSprAgrupaIndicador" formControlName="idSprAgrupaIndicador" class="is-invalid">
                            <select class="form-select form-control-sm " id="idSprAmbiente" formControlName="idSprAmbiente" required (ngModelChange)="obtenerObjetivos($event)" [ngClass]="{'is-invalid': this.formAgrupacionIndicador.get('idSprAmbiente')?.errors && this.formSubmitted,'is-valid': !this.formAgrupacionIndicador.get('idSprAmbiente')?.errors,}">
                                <option selected value="">Seleccione</option>
                                <option *ngFor="let item of dataAmbientesInferior" [ngValue]="item.idSprAmbiente">
                                    {{item.nombreUnidad}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formAgrupacionIndicador.get('idSprAmbiente')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-4 text-md-right">
                            <label for="idSprObjetivo" class=" form-control-label text-md-right pt-1"><b>Objetivos/ N.
                                    Inferior:</b></label>
                        </div>
                        <div class="col-12 col-md-8">
                            <select class="form-select form-control-sm " id="idSprObjetivo" formControlName="idSprObjetivo" required="true" (ngModelChange)="obtenerIndicadores($event)" [ngClass]="{'is-invalid': this.formAgrupacionIndicador.get('idSprObjetivo')?.errors && this.formSubmitted,'is-valid': !this.formAgrupacionIndicador.get('idSprObjetivo')?.errors,}">
                                <option selected value="">Seleccione</option>
                                <option *ngFor="let item of dataObjetivo" [ngValue]="item.idSprObjetivo">
                                    {{item.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formAgrupacionIndicador.get('idSprObjetivo')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-4 text-md-right">
                            <label for="idSprIndicadorHijo" class=" form-control-label text-md-right pt-1"><b>Indicadores/ N.
                                    Inferior:</b></label>
                        </div>
                        <div class="col-12 col-md-8">
                            <select class="form-select " id="idSprIndicadorHijo" formControlName="idSprIndicadorHijo" required="true" (ngModelChange)="comparaConfiguracion($event)" [ngClass]="{'is-invalid': this.formAgrupacionIndicador.get('idSprIndicadorHijo')?.errors && this.formSubmitted,'is-valid': !this.formAgrupacionIndicador.get('idSprIndicadorHijo')?.errors,}">
                                <option selected value="">Seleccione</option>
                                <option *ngFor="let item of dataIndicadorInferior" [ngValue]="item.idSprIndicador">
                                    {{item.nombre}}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formAgrupacionIndicador.get('idSprIndicadorHijo')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</small>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="this.openlabelValor == true" class="form-group row mb-2">
                        <div class="col col-md-4 text-md-right">
                            <label for="valor" class="form-control-label text-md-right pt-1"><b>Ponderación
                                    (%):</b></label>
                        </div>
                        <div class="col-12 col-md-6">
                            <input type="number" class="form-control" id="valor" min="0" max="100" step="0.01" maxlength="6" required="true" placeholder="" onkeypress="return ((event.charCode == 44 || event.charCode == 46) || (event.charCode>= 48 && event.charCode <= 57))" formControlName="valor"
                                [ngClass]="{'is-invalid': this.formAgrupacionIndicador.get('valor')?.errors && this.formSubmitted,'is-valid': !this.formAgrupacionIndicador.get('valor')?.errors, }" />
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formAgrupacionIndicador.get('valor')?.errors?.['required'] && this.formSubmitted">Campo
                                    requerido</span>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModalFormularioAgrupacion();">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="crearAgrupacionIndicador()">Guardar</button>
            </div>
        </div>

    </div>
</jw-modal>

<jw-modal id="eliminaAgrupacionIndicador" class="index">
    <div class="modal-dialog" style="padding-top:15%">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                <button type="button" class="btn-close" (click)="modal.closeId('eliminaAgrupacionIndicador')"></button>
            </div>
            <div class="modal-body">
                <p class="pl-4"><i class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp; &nbsp; Esta seguro que desea eliminar este registro..? </p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="modal.closeId('eliminaAgrupacionIndicador')">Cerrar</button>
                <button type="button" class="btn btn-primary" (click)="confirmDeleteAgrupacion()">Si, borrar!</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</jw-modal>